import {atom} from 'jotai';

export const totalNotificationsAtom = atom(0);
